<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>{{ contentId ? "Edit Story" : "Add New Story" }}</h1>
  </div>

  <div class="form-wrapper" *ngIf="!contentLoading">
    <form [formGroup]="form">
      <div class="grid-wrapper">
        <div class="full-width-Wrapper">
          <div class="grid-wrapper contentLang-wrapper">
            <div class="full-width-Wrapper">
              <div class="lang-wrapper">
                <label class="block-pointer">
                  <mat-form-field>
                    <mat-select placeholder="Language" formControlName="langId"
                      (selectionChange)="onLanguageSelect($event)">
                      <mat-option *ngFor="let lang of languages" [value]="lang.id">
                        {{ lang.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('langId')?.hasError('required')">
                      Language is required
                    </mat-error>
                  </mat-form-field>
                </label>
              </div>
            </div>

            <div class="div-grid-wrapper full-width-Wrapper">
              <label class="block-pointer">
                <span>Story Title</span>
                <mat-form-field>
                  <input type="text" matInput placeholder="Story Title" formControlName="name" maxlength="201" />
                  <mat-error *ngIf="form.get('name')?.hasError('required')">Story title is required</mat-error>
                  <mat-error *ngIf="form.get('name')?.hasError('maxlength')">Story title cannot exceed 200
                    characters</mat-error>
                  <mat-error *ngIf="form.get('name')?.hasError('onlySpaces')">Story title cannot be empty
                    spaces</mat-error>
                  <mat-error *ngIf="form.get('name')?.hasError('onlySpecialChars')">Story title cannot contain only
                    special characters</mat-error>
                </mat-form-field>
              </label>

              <label class="block-pointer">
                <span>Written By</span>
                <mat-form-field>
                  <input type="text" matInput placeholder="Written By" formControlName="writtenBy" maxlength="61" />
                  <mat-error *ngIf="form.get('writtenBy')?.hasError('required')">Written by is required</mat-error>
                  <mat-error *ngIf="form.get('writtenBy')?.hasError('maxlength')">Written By cannot exceed 60
                    characters</mat-error>
                  <mat-error *ngIf="form.get('writtenBy')?.hasError('onlySpaces')">Written By cannot be empty
                    spaces</mat-error>
                  <mat-error *ngIf="
                      form.get('writtenBy')?.hasError('onlySpecialAlphaChars')
                    ">Written By cannot contain only special characters and
                    numbers</mat-error>
                </mat-form-field>
              </label>

              <label>
                <span>Points</span>
                <mat-form-field appearance="fill">
                  <input matInput type="string" formControlName="point" placeholder="Points"
                    (keydown.space)="$event.preventDefault()" (keydown)="blockNegativeNumbers($event)"
                    (paste)="onPaste($event)" />
                  <mat-error *ngIf="form.get('point')?.hasError('required')">
                    Points are required
                  </mat-error>
                  <mat-error *ngIf="form.get('point')?.hasError('min')">
                    Points must be between 1 and 500
                  </mat-error>
                  <mat-error *ngIf="form.get('point')?.hasError('max')">
                    Points must be between 1 and 500
                  </mat-error>
                  <mat-error *ngIf="form.get('point')?.hasError('numbersOnly')">
                    Points must be an integer value
                  </mat-error>
                </mat-form-field>
              </label>

              <label>
                <span>Sort Order</span>
                <mat-form-field appearance="fill">
                  <input matInput type="number" formControlName="sortOrder" placeholder="Sort Order" />
                </mat-form-field>
            <mat-error *ngIf="
              form.get('sortOrder')?.hasError('required') &&
              (form.get('sortOrder')?.touched || isSubmitting)
            ">
              Sort Order is required
            </mat-error>

                <mat-error *ngIf="form.get('sortOrder')?.hasError('min')">
                  Sort Order must be at least 1
                </mat-error>

                <mat-error *ngIf="form.get('sortOrder')?.hasError('numbersOnly')">
                  Sort Order must be an integer value
                </mat-error>
              </label>
            </div>

            <label class="full-width-Wrapper block-pointer">
              <span>Story Description</span>
              <mat-form-field class="example-full-width">
                <textarea matInput placeholder="Description" formControlName="description" maxlength="1501"></textarea>
                <mat-error *ngIf="form.get('description')?.hasError('required')">
                  Description is required
                </mat-error>
                <mat-error *ngIf="form.get('description')?.hasError('maxlength')">
                  Description cannot exceed 3000 characters
                </mat-error>
                <mat-error *ngIf="form.get('description')?.hasError('onlySpaces')">
                  Description cannot be empty spaces
                </mat-error>
                <mat-error *ngIf="form.get('description')?.hasError('onlySpecialAlphaChars')">
                  Description cannot contain only special characters and numbers
                </mat-error>
              </mat-form-field>
            </label>

            <label class="full-width-Wrapper block-pointer">
              <span>Moral of story</span>
              <mat-form-field class="example-full-width">
                <textarea matInput placeholder="Moral of story" formControlName="moral"></textarea>

                <mat-error *ngIf="form.get('moral')?.hasError('required')">
                  Moral is required
                </mat-error>
                <mat-error *ngIf="form.get('moral')?.hasError('maxlength')">
                  Moral cannot exceed 500 characters
                </mat-error>
                <mat-error *ngIf="form.get('moral')?.hasError('onlySpaces')">
                  Moral cannot be empty spaces
                </mat-error>
                <mat-error *ngIf="form.get('moral')?.hasError('onlySpecialAlphaChars')">
                  Moral cannot contain only special characters and numbers
                </mat-error>
              </mat-form-field>


            </label>


            <label class="block-pointer">
              <span>Upload Thumb Image</span>
              <div class="borderedWrapper">
                <div class="fileSection">
                  <label for="thumbFile" class="unblock-pointer">
                    Choose A File
                    <input type="file" id="thumbFile" #thumbfileInput (change)="onThumbUpload($event)"
                      accept=".jpeg, .jpg, .png, .webp" />
                  </label>
                  <div class="uploadedFiles" *ngIf="thumbFileName">
                    <ul>
                      <li>
                        <h6>{{ thumbFileName }}</h6>
                        <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" style="cursor: pointer"
                          class="unblock-pointer" (click)="clearThumbUpload()" />
                      </li>
                    </ul>
                  </div>
                </div>
                <h6>
                  Image should be in JPG, JPEG or PNG format and not exceed 15MB
                  in size.
                </h6>
              </div>
            </label>

            <div class="audio-video-wrapper">
              <span>
                <div class="audioActionWrapper">
                  <label class="checkbox-option">
                    <input type="checkbox" [checked]="audioSource === 'upload'" (click)="
                        $event.preventDefault(); setAudioSource('upload')
                      " class="hidden-checkbox" [attr.aria-checked]="audioSource === 'upload'" />
                    <h6 [class.activeSelector]="audioSource === 'upload'">
                      Upload audio
                    </h6>
                  </label>

                  <label class="checkbox-option">
                    <input type="checkbox" [checked]="audioSource === 'url'"
                      (click)="$event.preventDefault(); setAudioSource('url')" class="hidden-checkbox"
                      [attr.aria-checked]="audioSource === 'url'" />
                    <h6 [class.activeSelector]="audioSource === 'url'">
                      Audio URL
                    </h6>
                  </label>
                </div>
              </span>
              <div class="borderedWrapper">
                <div class="fileSection" [class.hidden-section]="audioSource !== 'upload'">
                  <label for="audioFile" [class.hidden-section]="audioSource !== 'upload'">
                    Choose A File
                    <input type="file" id="audioFile" (change)="onAudioUpload($event)" accept=".mp3, .wav"
                      #audiofileInput />
                  </label>
                  <div class="uploadedFiles" [class.hidden-section]="audioSource !== 'upload'" *ngIf="audioFileName">
                    <ul>
                      <li>
                        <h6>{{ audioFileName }}</h6>
                        <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" class="unblock-pointer"
                          style="cursor: pointer" (click)="clearAudioUpload()" />
                      </li>
                    </ul>
                  </div>
                </div>
                <h6 [class.hidden-section]="audioSource !== 'upload'">
                  Audio should be in MP3 or WAV format and not exceed 100MB in
                  size.
                </h6>
                <div [class.hidden-section]="audioSource !== 'url'">
                  <input type="text" matInput placeholder="Audio URL" formControlName="audioUrl" class="urlInput" />
                </div>
                <h6 [class.hidden-section]="audioSource !== 'url'">
                  Audio should be in MP3 or WAV format
                </h6>
              </div>
            </div>

            <div class="audio-video-wrapper">
              <span>
                <div class="audioActionWrapper">
                  <label class="checkbox-option">
                    <input type="checkbox" [checked]="videoSource === 'upload'" (click)="
                        $event.preventDefault(); setVideoSource('upload')
                      " class="hidden-checkbox" [attr.aria-checked]="videoSource === 'upload'" />
                    <h6 [class.activeSelector]="videoSource === 'upload'">
                      Upload Video
                    </h6>
                  </label>

                  <label class="checkbox-option">
                    <input type="checkbox" [checked]="videoSource === 'url'"
                      (click)="$event.preventDefault(); setVideoSource('url')" class="hidden-checkbox"
                      [attr.aria-checked]="videoSource === 'url'" />
                    <h6 [class.activeSelector]="videoSource === 'url'">
                      Video URL
                    </h6>
                  </label>
                </div>
              </span>
              <div class="borderedWrapper">
                <div class="fileSection" [class.hidden-section]="videoSource !== 'upload'">
                  <label for="videoFile" [class.hidden-section]="videoSource !== 'upload'">
                    Choose A File
                    <input type="file" id="videoFile" (change)="onVideoUpload($event)" accept=".mp4, .mov"
                      #videofileInput />
                  </label>
                  <div class="uploadedFiles" [class.hidden-section]="videoSource !== 'upload'" *ngIf="videoFileName">
                    <ul>
                      <li>
                        <h6>{{ videoFileName }}</h6>
                        <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" class="unblock-pointer"
                          style="cursor: pointer" (click)="clearVideoUpload()" />
                      </li>
                    </ul>
                  </div>
                </div>
                <h6 [class.hidden-section]="videoSource !== 'upload'">
                  Video should be in MP4 or MOV format and not exceed 300MB in
                  size.
                </h6>
                <div [class.hidden-section]="videoSource !== 'url'">
                  <input type="text" matInput placeholder="Video URL" formControlName="videoUrl" class="urlInput" />
                </div>
                <h6 [class.hidden-section]="videoSource !== 'url'">
                  Video should be in MP4 or MOV format
                </h6>
              </div>
            </div>

            <label class="full-width-Wrapper block-pointer">
              <div class="storySection">
                <div class="sectionAddWrapper">
                  <span>Story Section</span>
                </div>
                <div formArrayName="sections">
                  <div *ngFor="let section of sections.controls; let i = index" [formGroupName]="i"
                    class="story-section">
                    <div class="bordered-section-wrapper">
                      <div class="remove-section-btn" *ngIf="sections.length > 1">
                        <button *ngIf="!translateContentId" type="button">
                          <img *ngIf="sections.length > 1" (click)="removeSection(i)"
                            src="../../../assets/images/icons/icon-close.svg" alt="Remove" />
                        </button>
                        <div class="page-no-div">
                          <span>Page no {{ i + 1 }}</span>
                        </div>
                      </div>
                      <div class="actionWrapper">
                        <div>
                          <span>Section Controls</span>
                        </div>

                        <div>
                          <div class="color-wrapper">
                            <span>Background color</span>
                            <label class="block-pointer">
                              <mat-form-field>
                                <input matInput type="color" formControlName="color" />
                              </mat-form-field>
                            </label>
                          </div>
                        </div>
                      </div>

                      <label class="contentDiv block-pointer">
                        <span>Story Content</span>
                        <mat-form-field class="example-full-width">
                          <textarea matInput placeholder="Story content" formControlName="content" maxlength="1501"
                            class="content-textarea"></textarea>
                          <mat-error *ngIf="section.get('content')?.hasError('required')">Story Content is
                            required</mat-error>
                          <mat-error *ngIf="
                              section.get('content')?.hasError('maxlength')
                            ">Story content cannot exceed 1500
                            characters</mat-error>
                          <!-- <mat-error
                            *ngIf="
                              section.get('content')?.hasError('minlength') &&
                              !section
                                .get('content')
                                ?.hasError('onlySpecialAlphaChars') &&
                              !section
                                .get('content')
                                ?.hasError('onlySpecialChars')
                            "
                          >
                            Story content must contain at least 150 characters
                          </mat-error> -->
                          <mat-error *ngIf="
                              section
                                .get('content')
                                ?.hasError('onlySpecialChars')
                            ">Story content cannot contain only special
                            characters</mat-error>
                          <mat-error *ngIf="
                              section
                                .get('content')
                                ?.hasError('onlySpecialAlphaChars')
                            ">Story Content cannot contain only special
                            characters and numbers</mat-error>
                        </mat-form-field>
                      </label>

                      <label class="block-pointer">
                        <span>Upload Image</span>
                        <div class="borderedWrapper">
                          <div class="fileSection">
                            <label class="unblock-pointer" for="imageFile{{ i }}">
                              Choose A File
                              <input type="file" id="imageFile{{ i }}" #imageFileInputs
                                (change)="onImageUpload($event, i)" accept=".jpeg, .jpg, .png, .webp" />
                            </label>
                            <div class="uploadedFiles" *ngIf="imageNameUrls[i]">
                              <ul>
                                <li>
                                  <h6>{{ imageNameUrls[i] }}</h6>
                                  <img src="../../../assets/images/icons/icon-close.svg" alt="Remove"
                                    style="cursor: pointer" class="unblock-pointer" (click)="clearImageUpload(i)" />
                                </li>
                              </ul>
                            </div>
                          </div>
                          <h6>
                            Image should be in JPG, JPEG, or PNG format and not
                            exceed 15MB in size.
                          </h6>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" class="add-page unblock-pointer" (click)="addSectionWithConfirmation()">
                Add Page
              </button>
            </label>
          </div>
        </div>

        <label class="full-width-Wrapper">
          <span>Tags</span>
          <div class="tags-collection">
            <div class="tags-item" *ngFor="let tag of tags" [ngClass]="{
                'tags-choosed': isTagSelected(tag),
                'tags-item': !isTagSelected(tag)
              }" (click)="toggleTagSelection(tag)" style="cursor: pointer">
              <h6>{{ tag.name }}</h6>
            </div>
          </div>
        </label>
      </div>

      <div class="submit-btn-wrapper">
        <button type="button" class="cmn-cancel-btn" (click)="onCancel()">
          Cancel
        </button>
        <button (click)="createContent()" [disabled]="isSubmitting" type="submit" class="cmn-next-btn">
          <span>{{ contentId ? "Update" : "Save" }}</span>
        </button>
      </div>
    </form>
  </div>
  <app-content-loader [visible]="contentLoading"></app-content-loader>
</section>

<app-fullscreen-loader [visible]="
    videoUploading ||
    thumbUploading ||
    imageUploading ||
    audioUploading ||
    loading
  " [message]="
    videoUploading || thumbUploading || imageUploading || audioUploading
      ? 'Uploading file, please wait...'
      : 'Saving, Please wait'
  ">
</app-fullscreen-loader>
